import {
    InputAdornment,
    IconButton,
    TextField
} from "@mui/material";
import ImageIcon from '@mui/icons-material/Image';
import React, { ReactElement, useRef, useState } from "react";
import { FileInputModal, FileInputModalProps } from "./FileInputModal";

export type FileInputAdornmentBasicProps = {
    label?: string,
    name?: string, 
    value?: string,
    multiple?: boolean;
    required?: boolean;
    fileTypes?: string[];
    path?: string;
    onChange: any,
    includeDomain?: boolean;
    icon?: ReactElement;
};

export const FileInputAdornmentBasic = (props: FileInputAdornmentBasicProps) => {
    const {
        label, 
        value,
        name,
        fileTypes= ["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"],
        multiple = true,
        required = false,
        path = "admin/media",
        onChange,
        includeDomain = false,
        icon = <ImageIcon />
    } = props;

    const [fieldValue, setFieldValue] = useState<string>(value ?? "");

    const setVars = (value) => {
        value = value
          .replaceAll(process.env.REACT_APP_AWS_CLOUDFRONT_URL, "%cloudFrontUrl%")
          .replaceAll(process.env.REACT_APP_BASE_URL, "%baseUrl%");
        return value;
    };

    const setPaths = (paths) => {
        let pathsJoin = paths.join(", ");

        setFieldValue(pathsJoin);
        onChange(pathsJoin, name);
    };

    const onFieldChange = (event) => {
        setFieldValue(event.target.value);
        onChange(event.target.value, name);
    };

    const fileInputModalRef = useRef<any>();
    const modalProps:FileInputModalProps =  {
        multiple:multiple,
        path: path,
        fileTypes:fileTypes,
        paths: value !== null ? value.split(", ") :  [],
        setPaths: setPaths,
        includeDomain: includeDomain
    }

    const openModal = () => {
        const currentRef = fileInputModalRef.current;
        if (currentRef) {
            currentRef.handleOpen()
        }
    };

    return (
        <React.Fragment>
            <FileInputModal ref={fileInputModalRef} {...modalProps}></FileInputModal>

            <TextField
                label={label}
                value={setVars(fieldValue)}
                required={required}
                size="small"
                name={name}
                onChange={onFieldChange}
                InputProps={{
                    endAdornment:  
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="file picker"
                            onClick={openModal}
                            edge="end"
                        >
                            {icon}
                        </IconButton>
                    </InputAdornment>
                }}
            ></TextField>  
        </React.Fragment>
    );
};